import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const getOrganizationsOptions = (channel?: string) =>
  queryOptions({
    queryKey: [{ entity: "organizations", params: { org_type: channel } }],
    queryFn: async () => await apiClient.getOrganizations({ queries: { org_type: channel } }),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
